module.exports = __webpack_public_path__ + "img/mug_view1.f11438b9.png";